import { of } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { logger } from '../../util/logger';
import { SubscriptionManager } from '@streem/toolbox';
import { takeFirstEmitted } from '../../util/rx/take_first_emitted';
import { recordMicrophoneStatusSet } from '@streem/analytics';
class AudioController {
    constructor(config) {
        this.config = config;
        this.log = logger.extend('sdk:audio_controller');
        this.subscriptions = new SubscriptionManager();
        this.audioTrackWallItem = config.wallItem.pipe(shareReplay(1));
        const trackSourceSub = config.trackSource.subscribe(audioTrack => {
            if (audioTrack) {
                this.audioTrack = audioTrack;
            }
        });
        this.subscriptions.add(trackSourceSub);
        this.connected = config.trackSource.pipe(map(track => !!track), shareReplay(1));
        this.enabled = config.trackSource.pipe(switchMap(audioTrack => {
            if (audioTrack) {
                return audioTrack.enabled.pipe(tap(enabled => this.log.info(`Track of type: audio has been ${enabled ? 'enabled' : 'disabled'} for participant: ${config.userId.toString()}`)));
            }
            else {
                return of(false);
            }
        }), shareReplay(1));
        this.started = config.trackSource.pipe(switchMap(audioTrack => {
            if (audioTrack) {
                return audioTrack.started.pipe(tap(started => this.log.info(`Track of type: audio has ${started ? 'started' : 'stopped'} for participant: ${config.userId.toString()}`)));
            }
            else {
                return of(false);
            }
        }), shareReplay(1));
        this.audioLevel = config.trackSource.pipe(switchMap(audioTrack => {
            if (audioTrack) {
                audioTrack.audioLevel.pipe(tap(audioLevel => this.log.info(`Audio level for ${audioTrack.trackLabel} is: ${audioLevel}`)));
                return audioTrack.audioLevel;
            }
            else {
                return of(0);
            }
        }), shareReplay(1));
        this.backgrounded = this.audioTrackWallItem?.pipe(map(item => !!item?.backgrounded), shareReplay(1));
    }
    disconnect() {
        this.subscriptions.unsubscribeAll();
    }
}
export class LocalAudioController extends AudioController {
    setEnabled(enable) {
        if (this.audioTrack) {
            this.audioTrack.setEnabled(enable);
            recordMicrophoneStatusSet(enable, this.config.roomId);
            this.log.info(`Track of type: audio has been turned ${enable ? 'ON' : 'OFF'} for participant: ${this.config.userId.toString()}`);
        }
    }
    async restart(constraints) {
        const success = await this.audioTrack?.restart(constraints);
        if (!success) {
            this.log.error(`Failed to successfully restart audio track for ${this.config.userId.toString()}`);
        }
        return success ?? false;
    }
    async setBackgrounded(backgrounded) {
        const wallItem = await takeFirstEmitted(this.audioTrackWallItem);
        this.config.roomWall.update(this.config.roomWall.builder.buildTrackWallItem('audioTrack', {
            ...wallItem,
            backgrounded,
        }));
        this.log.info(`audioTrack backgrounded value set to ${backgrounded} for:  ${this.config.userId.toString()}`);
    }
}
export class RemoteAudioController extends AudioController {
    constructor(config) {
        super(config);
        this.muted = this.audioTrackWallItem.pipe(map(item => !item?.active), shareReplay(1));
    }
    async selectSpeaker(deviceId) {
        return this.audioTrack?.selectSpeaker(deviceId, this.config.userId.toString());
    }
}
//# sourceMappingURL=audio_controllers.js.map